"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAddressModal = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var formik_1 = require("formik");
var postal_codes_js_1 = __importDefault(require("postal-codes-js"));
var react_1 = __importStar(require("react"));
var yup = __importStar(require("yup"));
var use_create_address_1 = require("../../hooks/use-create-address");
var use_saved_addresses_by_account_1 = require("../../hooks/use-saved-addresses-by-account");
var use_smartystreets_international_address_1 = require("../../hooks/use-smartystreets-international-address");
var format_street_address_1 = require("../../lib/format-street-address");
var country_code_select_1 = require("../country-code-select");
var country_state_select_1 = require("../country-state-select");
var shared_styled_components_1 = require("../shared-styled-components");
var verify_international_address_modal_1 = require("../verify-international-address-modal");
var schema = yup.object().shape({
    addressLine1: yup.string().required('A street address is required'),
    city: yup.string().required('A city is required'),
    stateOrArea: yup.string().required('A state or area is required'),
    countryCode: yup.string().required('A country code is required'),
    postalCode: yup
        .string()
        .test('postalCode', 'postalCode is not valid', function (value, context) {
        var validPostcode = postal_codes_js_1.default.validate(context.parent.countryCode, value !== null && value !== void 0 ? value : '');
        return typeof validPostcode === 'string' ? false : !!validPostcode;
    })
        .required('A zip/postal code is required'),
});
function CreateAddressModal(_a) {
    var _this = this;
    var accountUuid = _a.accountUuid, isOpen = _a.isOpen, toggle = _a.toggle, onSubmit = _a.onSubmit, _b = _a.width, width = _b === void 0 ? '600px' : _b;
    var createAddress = use_create_address_1.useCreateAddress();
    var _c = use_smartystreets_international_address_1.useSmartyStreetsInternationalAddress(), verifyInternationalAddress = _c[0], verifyInternationalAddressError = _c[2];
    var previouslySavedAddresses = use_saved_addresses_by_account_1.useSavedAddressesByAccount(accountUuid).data;
    var _d = react_1.useState(false), isValidating = _d[0], setIsValidating = _d[1];
    var _e = react_1.useState(false), isSubmitting = _e[0], setIsSubmitting = _e[1];
    var _f = react_1.useState(), internationalAddressResults = _f[0], setInternationalAddressResults = _f[1];
    var _g = react_1.useState(), selectedInternationalCandidate = _g[0], setSelectedInternationalCandidate = _g[1];
    var _h = react_1.useState('US'), locale = _h[0], setLocale = _h[1];
    var initialFormValues = {
        addressLine1: '',
        city: '',
        stateOrArea: '',
        postalCode: '',
        countryCode: 'USA',
        formattedAddress: '',
    };
    var form = formik_1.useFormik({
        validateOnBlur: true,
        validationSchema: schema,
        initialValues: initialFormValues,
        onSubmit: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setIsSubmitting(true);
                handleSubmit();
                return [2 /*return*/];
            });
        }); },
    });
    /**
     * handleSelectedInternationalVerifiedAddress
     * If an address is selected from the verified international address modal,
     * and populate form fields with verified address
     * Then call handleSubmit
     */
    function handleSelectedInternationalVerifiedAddress(selectedAddress) {
        if (!selectedAddress)
            return;
        var addressLine1 = selectedAddress.addressLine1, addressLine2 = selectedAddress.addressLine2, city = selectedAddress.city, stateOrArea = selectedAddress.stateOrArea, postalCode = selectedAddress.postalCode;
        setSelectedInternationalCandidate(selectedAddress);
        form.setFieldValue('addressLine1', addressLine1);
        form.setFieldValue('addressLine2', addressLine2);
        form.setFieldValue('city', city);
        form.setFieldValue('stateOrArea', stateOrArea);
        form.setFieldValue('postalCode', postalCode);
        setIsSubmitting(true);
        handleSubmit();
    }
    /**
     * handleSubmit
     * Convert form values to an Address.
     * if so, return existingAddress, otherwise create new address and return it.
     */
    function handleSubmit() {
        return __awaiter(this, void 0, void 0, function () {
            var address, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        address = format_street_address_1.transformFormValuesToAddress(form.values);
                        return [4 /*yield*/, createAddress({
                                accountUuid: accountUuid,
                                address: __assign(__assign({}, address), { formattedAddress: format_street_address_1.formatStreetAddress(address) }),
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        setIsSubmitting(false);
                        toggle(false);
                        if (onSubmit)
                            onSubmit(data);
                        return [2 /*return*/];
                }
            });
        });
    }
    /**
     * If 'international' has been selected, we format form data into an address and
     * verify it with smartystreets and saving it's result.
     * Otherwise call handleSubmit()
     */
    var handleVerification = react_1.useCallback(function () {
        function verifyCustomAddress() {
            return __awaiter(this, void 0, void 0, function () {
                var _a, countryCode, address, formattedAddress, response;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            setIsValidating(true);
                            _a = form.values, countryCode = _a.countryCode, address = __rest(_a, ["countryCode"]);
                            formattedAddress = format_street_address_1.formatStreetAddress(__assign(__assign({}, address), { countryCode: countryCode }));
                            return [4 /*yield*/, verifyInternationalAddress(countryCode, formattedAddress)];
                        case 1:
                            response = _b.sent();
                            setInternationalAddressResults(response === null || response === void 0 ? void 0 : response.result);
                            setIsValidating(false);
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (locale === 'international') {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            verifyCustomAddress();
        }
        else {
            handleSubmit();
        }
    }, [form.isValid, locale]);
    /**
     * When the form is toggled,
     * ensure form is reset and state is cleared
     */
    react_1.useEffect(function () {
        if (!isOpen) {
            form.resetForm();
            setIsSubmitting(false);
            setIsValidating(false);
            setSelectedInternationalCandidate(undefined);
            setInternationalAddressResults(undefined);
            setLocale('US');
        }
    }, [isOpen]);
    return (react_1.default.createElement(core_ui_1.Modal, { isOpen: !!isOpen, onToggle: function () { return toggle(!isOpen); }, width: width },
        react_1.default.createElement(core_ui_1.ModalBody, null,
            react_1.default.createElement(core_ui_1.ModalHeader, { titleText: "Add custom address", onClose: function () { return toggle(false); } }),
            react_1.default.createElement(core_ui_1.Padding, { size: 24 },
                react_1.default.createElement("form", { onSubmit: form.handleSubmit },
                    react_1.default.createElement(core_ui_1.Stack, { direction: "vertical", gap: 16 },
                        react_1.default.createElement(core_ui_1.SegmentedControl, { value: locale, options: [
                                {
                                    label: 'US',
                                    value: 'US',
                                },
                                {
                                    label: 'International',
                                    value: 'international',
                                },
                            ], onChange: function (val) { return setLocale(val); } }),
                        locale === 'international' && (react_1.default.createElement(core_ui_1.Field, { fieldId: "country-code", label: "Country" },
                            react_1.default.createElement(country_code_select_1.CountryCodeSelect, { value: form.values.countryCode, onChange: function (value) {
                                    // When the countryCode is selected, make sure
                                    // state is reset (and automatically repopulated in relevance to countryCode)
                                    // as well as stateOrArea/postalCode to ensure user data
                                    // is entered 'in order' and somewhat correctly.
                                    form.setFieldValue('countryCode', value);
                                    form.setFieldValue('city', '');
                                    form.setFieldValue('stateOrArea', '');
                                    form.setFieldValue('postalCode', '');
                                    setSelectedInternationalCandidate(undefined);
                                } }))),
                        react_1.default.createElement(core_ui_1.Field, { fieldId: "street-address-line-1", label: "Address line 1*", error: form.errors.addressLine1 },
                            react_1.default.createElement(core_ui_1.Input, { type: "text", name: "street-address-line-1", value: form.values.addressLine1, onChange: function (value) {
                                    form.setFieldValue('addressLine1', value);
                                } })),
                        react_1.default.createElement(core_ui_1.Field, { fieldId: "street-address-line-2", label: "Address line 2" },
                            react_1.default.createElement(core_ui_1.Input, { type: "text", name: "street-address-line-2", value: form.values.addressLine2, onChange: function (value) {
                                    form.setFieldValue('addressLine2', value);
                                } })),
                        react_1.default.createElement(shared_styled_components_1.Styled2Column, { minWidth: "600px" },
                            react_1.default.createElement(core_ui_1.Padding, { right: 8 },
                                react_1.default.createElement(core_ui_1.Field, { fieldId: "city", label: "City*", error: form.errors.city },
                                    react_1.default.createElement(core_ui_1.Input, { type: "text", name: "city", value: form.values.city, onChange: function (value) {
                                            form.setFieldValue('city', value);
                                        } }))),
                            react_1.default.createElement(core_ui_1.Padding, { left: 8 },
                                react_1.default.createElement(core_ui_1.Field, { fieldId: "state", label: "State*", error: form.errors.stateOrArea },
                                    react_1.default.createElement(country_state_select_1.CountryStateSelect, { value: form.values.stateOrArea, countryCode: form.values.countryCode, onChange: function (value) {
                                            form.setFieldValue('stateOrArea', value);
                                        } })))),
                        react_1.default.createElement(core_ui_1.Field, { fieldId: "zip", label: "Zip*", error: form.errors.postalCode },
                            react_1.default.createElement(core_ui_1.Input, { type: "text", name: "zip", value: form.values.postalCode, onChange: function (value) {
                                    form.setFieldValue('postalCode', value);
                                } })),
                        !selectedInternationalCandidate &&
                            internationalAddressResults &&
                            internationalAddressResults.length > 0 && (react_1.default.createElement(verify_international_address_modal_1.VerifyInternationalAddressModal, { candidates: internationalAddressResults, enteredAddress: format_street_address_1.transformFormValuesToAddress(form.values), isOpen: !!internationalAddressResults, onSelectAddress: handleSelectedInternationalVerifiedAddress, handleClose: function () {
                                // We're not validating address info as its inputted in the form.
                                // So, if the user cancels the verify modal (to perhaps tweak a field value), ...
                                // we can clear some input values so the yup schema can place the form in an invalid state.
                                // This forces the user to make required updates, and select city/state/zip again.
                                // Otherwise the form just thinks it has complete string values (no validation of values) and wont
                                // re-verify on an updated valid address.
                                // Also it seems to makes sense to wipe these 3 related fields, rather than just 1 to ensure
                                // data is entered 'in order' and 'correctly'
                                form.setFieldValue('city', '');
                                form.setFieldValue('stateOrArea', '');
                                form.setFieldValue('postalCode', '');
                                setInternationalAddressResults(undefined);
                            }, width: "500px" })),
                        react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center", justifyContent: "flex-end" },
                            react_1.default.createElement(core_ui_1.Button, { type: "button", size: "secondary", onClick: function () { return toggle(false); } }, "Cancel"),
                            react_1.default.createElement(core_ui_1.Spacing, { width: 12 }),
                            react_1.default.createElement(core_ui_1.Button, { type: "button", onClick: handleVerification, loading: !verifyInternationalAddressError && (isSubmitting || isValidating), disabled: !!verifyInternationalAddressError || isSubmitting || isValidating || !form.isValid }, "Submit"))))))));
}
exports.CreateAddressModal = CreateAddressModal;
